module.exports = {"NUM_BCARD_IMAGES_MAX_LIMIT":5,"NUM_BCARD_MAX_BYTE_PER_IMAGE":5242880,"NUM_EDITCORP_MAX_LIMIT":50,"NUM_FAVORITE_MAX_LIMIT":20,"NUM_BCARD_IMPORT_TAG":5}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.env.json
// module id = 6un8
// module chunks = 1